import React from 'react';

function ComponentIsEmpty() {
  return (
    <div className="status-page">
      <div className="status-content">
        <div className="status-illustration">
          {/* Aquí iría la imagen o ilustración */}
        </div>
        <h1>Ups, link expirado</h1>
        <p>
          Parece que el enlace para acceder ya no está activo o el formulario ya
          fue completado anteriormente 🙂.
        </p>
        <div className="container-request-button">
          {' '}
          <a
            className="btn btn-primary request-button"
            href="https://growtty.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ir a growtty
          </a>
        </div>

        {/* <div className="status-footer">
          Si crees que esto es un error o necesitas asistencia adicional, no
          dudes en, solicitar un nuevo enlace o <a href="#">contactarnos.</a>{' '}
          Estamos aquí para ayudarte. 🙂
        </div> */}
      </div>
    </div>
  );
}

export default ComponentIsEmpty;
